import { useMemo, useState } from "react"
import { DialogContent } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { StandardButton } from "../../../../../../shared/components/buttons/StandardButton"
import { UserDetailsProps } from "../../../../../../shared/components/createOrder/orderOnBehalf/OrderOnBehalfFlow"
import { OrderOnBehalfScope } from "../../../../../../shared/components/createOrder/orderOnBehalf/orderOnBehalfTypes"
import { UserSelector } from "../../../../../../shared/components/createOrder/orderOnBehalf/UserSelector"
import { StandardDialog } from "../../../../../../shared/components/dialogs/StandardDialog"
import { useCurrentCompany } from "../../../../../company/hooks/useCurrentCompany"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { UserType } from "../../../../../login/loginTypes"

import { WorkgroupMember } from "../workgroupsTypes"

const useStyles = makeStyles()((theme) => ({
    dialogContent: {
        padding: "2.5rem",
        paddingTop: "1rem",
        display: "flex",
        gap: "2rem",
        flexDirection: "column",
        color: theme.palette.tailwind.slate[950],
    },
}))

type AddWorkgroupMemberDialogProps = Readonly<{
    open: boolean
    excludedUserIds: ReadonlyArray<number>
    onClose: () => void
    onAdd: (member: WorkgroupMember) => void
}>

export function AddWorkgroupMemberDialog({ open, excludedUserIds, onClose, onAdd }: AddWorkgroupMemberDialogProps) {
    const { classes } = useStyles()
    const { companyId } = useCurrentCompany()
    const [userDetails, setUserDetails] = useState<UserDetailsProps>({})

    const scope = useMemo<OrderOnBehalfScope>(() => ({ type: UserType.COMPANY, companyId }), [companyId])
    const { selectedUserId, selectedUserName } = userDetails

    return (
        <StandardDialog
            dialogTitle={
                <LocalizedStrict id="create-or-edit-company-workgroup-members-add-dialog-title">
                    <>Add member</>
                </LocalizedStrict>
            }
            open={open}
            onClose={onClose}
            maxWidthProp="sm"
            scroll="body"
        >
            <DialogContent className={classes.dialogContent}>
                <UserSelector
                    scope={scope}
                    userDetails={userDetails}
                    setUserDetails={setUserDetails}
                    labelTranslationKey="create-or-edit-company-workgroup-members-add-dialog-user-field"
                    excludedUserIds={excludedUserIds}
                />
                {selectedUserId && selectedUserName && (
                    <LocalizedStrict id="create-or-edit-company-workgroup-members-add-dialog-confirm-button">
                        <StandardButton
                            fullWidth={false}
                            onClick={() => onAdd({ id: selectedUserId, displayName: selectedUserName })}
                        >
                            Add
                        </StandardButton>
                    </LocalizedStrict>
                )}
            </DialogContent>
        </StandardDialog>
    )
}
